module.exports = __webpack_public_path__ + "static/img/jigou-guangxi-bottom.670bbf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-guangxi-bottom.png
// module id = 7hlE
// module chunks = 2